import React from 'react';
import { motion } from 'framer-motion';
import { trackCTAClick } from '../utils/metaPixel';
export function HeroSection() {
  const checkoutUrl = 'https://yennilemon.com/cart/44434972934279:1?country=MX&locale=es-MX';
  return <section className="relative bg-warm-white overflow-hidden pt-1 pb-4 md:py-20 lg:py-24 px-3 md:px-4" data-id="element-131">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-1.5 md:gap-12 items-center" data-id="element-132">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-1 md:space-y-5" data-id="element-133">
          {/* Headline */}
          <h1 className="md:hidden text-[clamp(18px,5.2vw,24px)] font-heading font-bold text-olive leading-[1.1] text-center" data-id="element-134">
            ¿Te despiertas a las 3 am y amaneces agotada?
          </h1>
          <h1 className="hidden md:block text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-olive leading-tight" data-id="element-135">
            ¿Te despiertas a las 3 am y amaneces agotada?
          </h1>

          {/* Subheadline */}
          <p className="text-[11px] md:text-xl text-warm-gray leading-snug md:leading-relaxed max-w-xl text-center md:text-left" data-id="element-136">
            <span className="md:hidden" data-id="element-137">
              Recupera tus mañanas con este protocolo diseñado para desinflamar
              tu cerebro y resetear tu reloj biológico.
            </span>
            <span className="hidden md:inline" data-id="element-138">
              Recupera tus mañanas con este protocolo diseñado para desinflamar
              tu cerebro y resetear tu reloj biológico.
            </span>
          </p>

          {/* Mobile ebook image — compact */}
          <div className="md:hidden flex justify-center -my-1" data-id="element-139">
            <img src="https://cdn.magicpatterns.com/uploads/v8a939Bf4gW8uB77fYPgVV/mockup3DS.webp" alt="El Interruptor del Sueño +40" className="max-w-[160px] w-[60%] h-auto object-contain drop-shadow-2xl" data-id="element-140" />
          </div>

          {/* Pricing Block — tighter on mobile */}
          <div className="bg-cream border-2 border-sage rounded-2xl p-3 md:p-8 text-center max-w-md mx-auto lg:mx-0 shadow-soft relative" data-id="element-141">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-sage text-white text-[9px] md:text-xs font-bold px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-142">
              👇 PRECIO DE LANZAMIENTO
            </div>

            <div className="flex items-center justify-center gap-2 text-warm-gray text-[10px] md:text-sm mt-1" data-id="element-143">
              <span className="line-through decoration-warm-accent/50" data-id="element-144">
                $497 MXN
              </span>
              <span className="bg-warm-accent text-white text-[9px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-145">
                -75% OFF
              </span>
            </div>

            <div className="text-3xl md:text-6xl font-bold text-olive font-heading py-0.5" data-id="element-146">
              $114 <span className="text-lg md:text-3xl" data-id="element-147">MXN</span>
            </div>

            <p className="text-sage font-medium text-[10px] md:text-sm" data-id="element-148">
              Solo por 3 días · Oferta de lanzamiento
            </p>

            <a href={checkoutUrl} onClick={trackCTAClick} className="block w-full mt-2.5 md:mt-4 bg-[#E8763A] hover:bg-[#D4682F] text-white font-extrabold py-3 md:py-4 px-6 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-[13px] md:text-lg text-center uppercase tracking-wide" data-id="element-149">
              SÍ, QUIERO DORMIR MEJOR POR $114 MXN
            </a>

            <p className="text-warm-gray text-[9px] md:text-xs mt-1.5 font-medium" data-id="element-150">
              Pago único • Descarga inmediata • Garantía 7 días
            </p>
            <p className="text-warm-gray/70 text-[9px] md:text-[11px] mt-0.5 leading-snug" data-id="element-151">
              🔒 Pago Seguro 100%. ¿Ayuda? 🇲🇽{' '}
              <a href="https://wa.me/16468066813?text=Hola%20Yenny,%20tengo%20una%20duda%20con%20El%20Interruptor%20del%20Sueño." target="_blank" rel="noopener noreferrer" className="text-[#25D366] font-semibold underline hover:text-[#1EBE5A]" data-id="element-152">
                WhatsApp
              </a>{' '}
              desde USA 🇺🇸
            </p>
          </div>
        </motion.div>

        {/* Image Content — desktop only */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative hidden lg:flex justify-center lg:justify-end" data-id="element-153">
          <div className="relative w-full max-w-lg" data-id="element-154">
            <div className="absolute inset-0 bg-sage/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-155"></div>
            <img src="https://cdn.magicpatterns.com/uploads/v8a939Bf4gW8uB77fYPgVV/mockup3DS.webp" alt="El Interruptor del Sueño +40" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-156" />
          </div>
        </motion.div>
      </div>
    </section>;
}